import { render, staticRenderFns } from "./CockpitMatryoshkaItemActionButtons.vue?vue&type=template&id=40acf3bc&scoped=true"
import script from "./CockpitMatryoshkaItemActionButtons.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaItemActionButtons.vue?vue&type=script&lang=js"
import style0 from "./CockpitMatryoshkaItemActionButtons.vue?vue&type=style&index=0&id=40acf3bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40acf3bc",
  null
  
)

export default component.exports